import { useNavigate } from 'react-router-dom';
import { BuilderWizard, WizardStep } from '@unwritten/builder';
import { Globe } from 'lucide-react';

export function WorldWizard() {
  const navigate = useNavigate();

  const steps: WizardStep[] = [
    {
      id: 'basics',
      title: 'Basic Info',
      description: 'Set up world name and description',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Basic world information form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'settings',
      title: 'World Settings',
      description: 'Configure world rules and parameters',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">World settings form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'lore',
      title: 'Lore & Theme',
      description: 'Define world lore and themes',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Lore configuration form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'review',
      title: 'Review',
      description: 'Review and create world',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Review screen coming soon...</p>
        </div>
      ),
    },
  ];

  const handleComplete = async (data: any) => {
    console.log('World created:', data);
    navigate('/worlds');
  };

  const handleCancel = () => {
    navigate('/worlds');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center gap-3 mb-6">
        <Globe className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold">Create New World</h1>
      </div>

      <BuilderWizard
        steps={steps}
        onComplete={handleComplete}
        onCancel={handleCancel}
        persistenceKey="world-wizard"
      />
    </div>
  );
}
